import { Directive, ElementRef, Input, NgZone, OnDestroy } from '@angular/core';

@Directive({
    selector: 'img[appAvatarImage]',
    standalone: true,
})
export class AvatarImageDirective implements OnDestroy {
    private usingFallback = false;
    private readonly image: HTMLImageElement;
    private readonly onLoad = () => this.image.classList.remove('avatar-image-loading');
    private readonly onError = () => {
        if (this.usingFallback) {
            this.onLoad();
            return;
        }
        this.usingFallback = true;
        this.image.src = 'placeHolderImage.jpg';
    };

    constructor(element: ElementRef<HTMLImageElement>, zone: NgZone) {
        this.image = element.nativeElement;
        // Thumbnail completion should not check every dropdown option again.
        zone.runOutsideAngular(() => {
            this.image.addEventListener('load', this.onLoad);
            this.image.addEventListener('error', this.onError);
        });
    }

    @Input() set appAvatarImage(url: string | null | undefined) {
        this.image.classList.add('avatar-image-loading');
        this.usingFallback = !url;
        this.image.src = url || 'placeHolderImage.jpg';
        if (this.image.complete && this.image.naturalWidth > 0) {
            this.onLoad();
        }
    }

    ngOnDestroy(): void {
        this.image.removeEventListener('load', this.onLoad);
        this.image.removeEventListener('error', this.onError);
    }
}
